import React from 'react';
import { useCapacidades } from './CapacidadesContext';

// Barra de filtros: Planta (fija, contexto) + Área (seleccionable, mismo look).
export default function FiltrosCapacidades() {
    const { areas, selectedArea, selectArea, canEdit } = useCapacidades();
    const plantaNombre = process.env.REACT_APP_PLANT_NAME || 'Planta';

    const handleAreaChange = (e) => {
        const area = areas.find((a) => String(a.area1) === String(e.target.value)) || null;
        selectArea(area);
    };

    return (
        <div className="cap-filtros">
            <div className="cap-filtro">
                <span className="cap-filtro-label">Planta</span>
                <div className="cap-filtro-planta">{plantaNombre}</div>
            </div>

            <div className="cap-filtro">
                <span className="cap-filtro-label">Área</span>
                <select
                    className="cap-filtro-selectbox"
                    value={selectedArea?.area1 ?? ''}
                    onChange={handleAreaChange}
                >
                    {areas.map((area) => (
                        <option key={area.area1} value={area.area1}>{area.nombre}</option>
                    ))}
                </select>
            </div>

            <div className="cap-filtros-meta">
                {!canEdit && <span className="cap-filtros-readonly">Solo lectura · Consulta</span>}
            </div>
        </div>
    );
}
